import { render, staticRenderFns } from "./EventLog.vue?vue&type=template&id=674c9aea&scoped=true"
import script from "./EventLog.vue?vue&type=script&lang=ts"
export * from "./EventLog.vue?vue&type=script&lang=ts"
import style0 from "./EventLog.vue?vue&type=style&index=0&id=674c9aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c9aea",
  null
  
)

export default component.exports